import 'core-js'
import React from 'react'
import ReactDOM from 'react-dom'
import ReactGA from 'react-ga'
import { Provider } from 'react-redux'
import * as serviceWorker from './serviceWorker'
import Routing from './modules/routing'
import JeffHeader from './shared/components/JeffHeader/JeffHeader'
import 'bootstrap/dist/css/bootstrap-grid.min.css'
import './index.scss'
import configureStore, { history } from './redux_setup/store'

const { store } = configureStore()
const analyticOptions = {}


if (process.env.NODE_ENV !== 'production') {
  const whyDidYouRender = require('@welldone-software/why-did-you-render')
  whyDidYouRender(React, { trackHooks: true, include: [/^ConnectFunction/] })
  analyticOptions.debug = true
}

ReactGA.initialize('UA-109326169-7', analyticOptions)

ReactDOM.render(
  <Provider store={store}>
    <JeffHeader />
    <Routing history={history} />
  </Provider>,
  document.getElementById('root')
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
